export const GET_BOARD_NAME_REQUEST = "GET_BOARD_NAME_REQUEST";
export const GET_BOARD_NAME_SUCCESS = "GET_BOARD_NAME_SUCCESS";
export const GET_BOARD_GENERAL_DATA = "GET_BOARD_GENERAL_DATA";
export const TOGGLE_SHOW_BOARD_CHENNEL = "TOGGLE_SHOW_BOARD_CHENNEL";
export const TOGGLE_SHOW_BOARD_SETTING = "TOGGLE_SHOW_BOARD_SETTING";
export const TOGGLE_SHOW_BOARD_AISTUDIO = "TOGGLE_SHOW_BOARD_AISTUDIO";
export const GET_BOARD_SETTING = "GET_BOARD_SETTING";

export const CHANGE_BOARD_PRIVACY_REQUEST = "CHANGE_BOARD_PRIVACY_REQUEST";
export const CHANGE_BOARD_PRIVACY_SUCCESS = "CHANGE_BOARD_PRIVACY_SUCCESS";
export const CHANGE_BOARD_PRIVACY_FAIL = "CHANGE_BOARD_PRIVACY_FAIL";
export const RESET_BOARD_PRIVACY_STAT = "RESET_BOARD_PRIVACY_STAT";
export const GET_BOARD_WORK_SETTING = "GET_BOARD_WORK_SETTING";
export const GET_BOARD_PANEL = "GET_BOARD_PANEL";
export const GET_BOARD_COLUMNS = "GET_BOARD_COLUMNS";
export const BOARD_TASK_LAYOUT = "BOARD_TASK_LAYOUT";
export const Delete_BOARD_COLUMN_SOCKET = "Delete_BOARD_COLUMN_SOCKET";
export const TOGGLE_SHOW_BOARD_CHARTER = "TOGGLE_SHOW_BOARD_CHARTER";
export const TOGGLE_SHOW_BOARD_CORRESPONDENCE =
  "TOGGLE_SHOW_BOARD_CORRESPONDENCE";
export const TOGGLE_SHOW_BOARD_MEETING_MINUTE =
  "TOGGLE_SHOW_BOARD_MEETING_MINUTE";
export const TOGGLE_SHOW_BOARD_DOCUMENTATION =
  "TOGGLE_SHOW_BOARD_DOCUMENTATION";
export const TOGGLE_SHOW_BOARD_ADVOCACY_REVIEW =
  "TOGGLE_SHOW_BOARD_ADVOCACY_REVIEW";
/** Idempotent open/close — use with URL sync so closing does not re-toggle open. */
export const SET_SHOW_BOARD_ADVOCACY_REVIEW = "SET_SHOW_BOARD_ADVOCACY_REVIEW";
export const TOGGLE_SHOW_BOARD_FORM = "TOGGLE_SHOW_BOARD_FORM";
export const TOGGLE_SHOW_BOARD_ARCHIVED_TASKS =
  "TOGGLE_SHOW_BOARD_ARCHIVED_TASKS";
export const TOGGLE_SHOW_BOARD_FINANCIAL = "TOGGLE_SHOW_BOARD_FINANCIAL";
export const TOGGLE_SHOW_BOARD_RESOURCES = "TOGGLE_SHOW_BOARD_RESOURCES";
export const TOGGLE_SHOW_CRM = "TOGGLE_SHOW_CRM";
export const TOGGLE_SHOW_CRISIS = "TOGGLE_SHOW_CRISIS";
export const TOGGLE_SHOW_DAILY_REPORT = "TOGGLE_SHOW_DAILY_REPORT";
export const TOGGLE_SHOW_REMINDER = "TOGGLE_SHOW_REMINDER";
export const TOGGLE_SHOW_BOARD_HABITS = "TOGGLE_SHOW_BOARD_HABITS";
export const TOOGLE_SHOW_SCREEN_CHECK = "TOOGLE_SHOW_SCREEN_CHECK";
export const TOOGLE_SHOW_CALENDER_CHECK = "TOOGLE_SHOW_CALENDER_CHECK";
export const TOOGLE_SHOW_WBS_CHECK = "TOOGLE_SHOW_WBS_CHECK";
export const TOGGLE_SHOW_BOARD_WHITE_SPACE = "TOGGLE_SHOW_BOARD_WHITE_SPACE";
export const TOGGLE_SHOW_BOARD_FLOW_CHART = "TOGGLE_SHOW_BOARD_FLOW_CHART";
export const TOOGLE_SHOW_SPRINT_MOOD = "TOOGLE_SHOW_SPRINT_MOOD";
export const SPRINT_MOOD_DATA = "SPRINT_MOOD_DATA";
export const SET_CALENDAR_ACTIVE_TIME = "SET_CALENDAR_ACTIVE_TIME";
export const SET_CALENDAR_SHOWING_MOOD = "SET_CALENDAR_SHOWING_MOOD";
export const REQUEST_OPEN_TASK_DETAIL = "REQUEST_OPEN_TASK_DETAIL";
/** @deprecated use REQUEST_OPEN_TASK_DETAIL */
export const OPEN_TASK_HOME_CALENDAR = REQUEST_OPEN_TASK_DETAIL;
export const TOGGLE_FULLSCREEN_CALENDAR = "TOGGLE_FULLSCREEN_CALENDAR";
export const CALENDAR_SHOW_LOOP_TASKS = "CALENDAR_SHOW_LOOP_TASKS";
export const NUMBER_FREE_JOINED_BOARD = "NUMBER_FREE_JOINED_BOARD";
export const BOARD_SIZE_LIMIT_SERVER = "BOARD_SIZE_LIMIT_SERVER";
export const BOARD_MENU_MODEL = "BOARD_MENU_MODEL";
export const GET_BOARD_AUTOMATIONS_SUCCESS = "GET_BOARD_AUTOMATIONS_SUCCESS";
export const DISCOUNT_CODE_CHECK = "DISCOUNT_CODE_CHECK";
export const NEW_USER_DISCOUNT_STATUS = "NEW_USER_DISCOUNT_STATUS";
export const GET_PROGRESS_CHART_DATA = "GET_PROGRESS_CHART_DATA";
export const GET_TASKMAPS_PROGRESS_CHART_DATA =
  "GET_TASKMAPS_PROGRESS_CHART_DATA";
export const NEW_CATEGORY_TASK = "NEW_CATEGORY_TASK";
export const GET_BOARDTEMPORARY_GOALS = "GET_BOARDTEMPORARY_GOALS";
export const GET_BOARD_HISTORY = "GET_BOARD_HISTORY";
export const GET_BOARD_USER_HISTORY = "GET_BOARD_USER_HISTORY";
export const GET_BOARD_RESOURCE_USAGE = "GET_BOARD_RESOURCE_USAGE";
export const GET_MEMBER_WORKLOAD = "GET_MEMBER_WORKLOAD";
export const SET_SHOWING_COS_ID = "SET_SHOWING_COS_ID";
